import React, {Component} from 'react';
import {Carousel} from "react-bootstrap";
import {Link} from "react-router-dom";
import "./carousel.css";
import {isEmptyString} from "../../utils/validators/Validator";

class CarouselPanel extends Component {
    render() {
        return (
            <Carousel controls={false} interval={5000}>
                {
                    this.props.items &&
                    this.props.items.map( (item, index) => {
                        return <Carousel.Item key={"carousel_item_" + index} className={"no-text-decor"} as={isEmptyString(item.link)?Carousel.Item: Link} to={item.link}>
                            <div className={"carousel_component"}>
                                {item.component}
                            </div>
                        </Carousel.Item>
                    })
                }
            </Carousel>
        );
    }
}

export default CarouselPanel;